__turbopack_context__.v({
  "cta-button": "mobile-comparison-table-module-scss-module__rR6fvq__cta-button",
  "link": "mobile-comparison-table-module-scss-module__rR6fvq__link",
  "plan-benefit": "mobile-comparison-table-module-scss-module__rR6fvq__plan-benefit",
  "plan-benefit-description": "mobile-comparison-table-module-scss-module__rR6fvq__plan-benefit-description",
  "plan-benefit-icon": "mobile-comparison-table-module-scss-module__rR6fvq__plan-benefit-icon",
  "plan-benefit-text": "mobile-comparison-table-module-scss-module__rR6fvq__plan-benefit-text",
  "plan-benefit-title": "mobile-comparison-table-module-scss-module__rR6fvq__plan-benefit-title",
  "plan-benefits": "mobile-comparison-table-module-scss-module__rR6fvq__plan-benefits",
  "plan-card": "mobile-comparison-table-module-scss-module__rR6fvq__plan-card",
  "plan-description": "mobile-comparison-table-module-scss-module__rR6fvq__plan-description",
  "plan-image": "mobile-comparison-table-module-scss-module__rR6fvq__plan-image",
  "plan-title": "mobile-comparison-table-module-scss-module__rR6fvq__plan-title",
  "plan-toggle": "mobile-comparison-table-module-scss-module__rR6fvq__plan-toggle",
  "plan-toggle-row": "mobile-comparison-table-module-scss-module__rR6fvq__plan-toggle-row",
  "theme-basic": "mobile-comparison-table-module-scss-module__rR6fvq__theme-basic",
  "theme-black": "mobile-comparison-table-module-scss-module__rR6fvq__theme-black",
  "theme-pink": "mobile-comparison-table-module-scss-module__rR6fvq__theme-pink",
  "theme-turquoise": "mobile-comparison-table-module-scss-module__rR6fvq__theme-turquoise",
  "title": "mobile-comparison-table-module-scss-module__rR6fvq__title",
});
